<li
	*ngIf="collectionService.state$ | async as collectionState"
	class="nav-item dropdown"
	style="list-style-type: none;"
>
	<div
		(openChange)="openChange($event)"
		ngbDropdown
		placement="bottom-right"
		role="group"
	>
		<button
			aria-label="Show collections"
			class="btn-circle"
			type="button"
			ngbDropdownToggle
		>
			<app-ikea-icon
				iconName="shopping_bag_yellow"
				[width]="iconSize"
				[height]="iconSize"
				[attr.data-badge]="collectionState.listOfCollections.length"
			></app-ikea-icon>
		</button>

		<div
			class="dropdown-menu dropdown-collection"
			aria-labelledby="dropdown05"
			ngbDropdownMenu
		>
			<div class="shared-list">
				<h5>My collections</h5>
				<ul>
					<li
						(click)="$event.stopPropagation()"
						(click)="setCreateMode()"
						*ngIf="!isCreateMode"
					>
						<div class="flex-item1">
							<img src="/assets/icon/plus-sign-create-collection.svg" />
						</div>
						<div class="flex-item2">
							Create new collection
						</div>
						<div class="flex-item3"></div>
						<div class="flex-item4"></div>
					</li>

					<li
						*ngIf="isCreateMode"
						(click)="$event.stopPropagation()"
						class="create-form"
					>
						<div class="flex-item1"></div>
						<div class="flex-item2">
							<input
								(keydown)="keydown($event)"
								[formControl]="createInputControl"
								#createCollectionNameField
								id="createCollectionNameField"
								placeholder="Name of new collection"
								type="text"
							/>
						</div>
						<div class="flex-item3"></div>
						<div class="flex-item4">
							<button
								type="button"
								class="btn visit-collection-btn"
								(click)="createCollection()"
							></button>
						</div>
					</li>

					<app-collection-list-item
						[collection]="collection"
						[isHighlighted]="
							collection.collectionId === collectionState.defaultCollectionId
						"
						(navigate)="closeDropdown()"
						*ngFor="let collection of sortedList$ | async"
					></app-collection-list-item>
				</ul>
			</div>
		</div>
	</div>
</li>
